export const timezoneOffsetCurrent = 3
export const apiPrivacyUrl = 'https://tione.api-used.ru'
